// Declaración global para Nakama
declare global {
  interface Window {
    nakamajs: any;
  }
}

class NakamaService {
  private client: any;

  constructor() {
    if (typeof window !== "undefined" && window.nakamajs) {
      this.client = new window.nakamajs.Client(
        "defaultkey",
        "nakama-aethel.yoyooinc.com", // para llevarlo a produccion se cambia el localhost por esta url, se elimina el puerto y se cambia el false a tru para el protocolo https
        // "localhost",
        "7350",
        true,
      );
    }
  }

  getClient() {
    if (!this.client) {
      throw new Error("Nakama client not initialized");
    }
    return this.client;
  }

  // Métodos de autenticación
  async authenticateEmail(
    email: string,
    password: string,
    create: boolean = false,
    username?: string,
  ) {
    const client = this.getClient();
    return await client.authenticateEmail(email, password, create, username);
  }

  // Métodos de cuenta
  async getAccount(session: any) {
    const client = this.getClient();
    return await client.getAccount(session);
  }

  // Métodos de almacenamiento
  async readStorageObjects(session: any, options: any) {
    const client = this.getClient();
    return await client.readStorageObjects(session, options);
  }

  async writeStorageObjects(session: any, objects: any[]) {
    const client = this.getClient();
    return await client.writeStorageObjects(session, objects);
  }

  // Restaurar sesión
  restoreSession(token: string, refreshToken: string) {
    return window.nakamajs.Session.restore(token, refreshToken);
  }
}

export const nakamaService = new NakamaService();
